module.exports = __webpack_public_path__ + "img/banner03.6f3dd6fb.png";